import type { TrackingContext } from '../_types';

/**
 * The `book_appointment` fields every analytics destination shares. Returns
 * null without a saleOrderId, since destinations dedupe on transaction_id.
 */
export const buildBookAppointmentPayload = (
  context: TrackingContext | undefined,
): Record<string, unknown> | null => {
  if (!context?.saleOrderId) return null;
  const payload: Record<string, unknown> = {
    value: Number(context.totalDollars ?? 0),
    currency: context.currency ?? 'USD',
    transaction_id: String(context.saleOrderId),
  };
  // shop_route carries the shopId: the in-app /booking/book/<shopId> route
  // resolves to the slug, so the id is the meaningful route value.
  if (context.shopName) payload.shop_name = context.shopName;
  if (context.shopId) payload.shop_route = context.shopId;
  return payload;
};
